import { render, staticRenderFns } from "./HomeProjectsSection.vue?vue&type=template&id=2ff309d5&scoped=true&"
import script from "./HomeProjectsSection.vue?vue&type=script&lang=js&"
export * from "./HomeProjectsSection.vue?vue&type=script&lang=js&"
import style0 from "./HomeProjectsSection.vue?vue&type=style&index=0&id=2ff309d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff309d5",
  null
  
)

export default component.exports